// ---------------
export const Constants = {
  //
  auth: {
    access_jwt_strategy_name: "access",
    refresh_jwt_strategy_name: "refresh",
  },

  auth_type: {
    none: "none",
    password: "password",
  },

  cookies: {
    refresh_token: "x-eagerdog-refresh-token",
  },

  user_type: {
    owner: "owner",
    club_manager: "club_manager",
    eagerdog_admin: "eagerdog_admin",
  },

  capacity_type: {
    participant: "participant",
    volunteer: "volunteer",
    member: "member",
    admin: "admin",
    follower: "follower",
    donor: "donor",
  },

  event_role: {
    gate_steward: "gate_steward",
  },

  ban_reason: {
    non_payment: "non_payment",
    code_of_conduct: "code_of_conduct",
    safety_concern: "safety_concern",
    fraudulent_entry: "fraudulent_entry",
    disruptive_behavior: "disruptive_behavior",
    other: "other",
  },

  dog_coowner_type: {
    owner: "owner",
    junior: "junior",
    handler: "handler",
  },

  token_type: {
    password: "password",
    refresh: "refresh",
    registration: "registration",
    email: "email",
    password_reset: "password_reset",
    email_change: "email_change",
  },

  notification_events: {
    email_verification_token: "email-verification-token",
    email_change_verification: "email-change-verification",
    email_welcome: "email-welcome",
    email_new_registration_dog_owner: "email_new_registration_dog_owner",
    email_entry_form_dog_owner: "email_entry_form_dog_owner",
    email_new_registration_kennel_club: "email_new_registration_kennel_club",
    email_send: "email-send",

    email_password_reset: "email_password_reset",
    email_results: "email_results",

    email_new_subscription: "email_new_subscription",
    email_send_message: "email_send_message",
    email_contacts_message: "email_contacts_message",
    email_new_arm_number_per_show_type: "email_new_arm_number_per_show_type",

    email_waitlist_canceled_dog_owner: "email_waitlist_canceled_dog_owner",
    email_waitlist_approved_dog_owner: "email_waitlist_approved_dog_owner",
    email_waitlist_on_behalf_approved_dog_owner:
      "email_waitlist_on_behalf_approved_dog_owner",
    email_waitlist_position_changed: "email_waitlist_position_changed",
    email_course_waitlist: "email_course_waitlist",

    email_lottery_registration_dog_owner:
      "email_lottery_registration_dog_owner",
    email_lottery_invitation_dog_owner: "email_lottery_invitation_dog_owner",
    email_lottery_losing_dog_owner: "email_lottery_losing_dog_owner",
    email_lottery_draw_results_dog_owner: "email_lottery_draw_results_dog_owner",
    email_refund_dog_owner: "email_refund_dog_owner",
    email_refund_kennel_club: "email_refund_kennel_club",
    email_refund_requested_kennel_club: "email_refund_requested_kennel_club",
    email_refund_requested_dog_owner: "email_refund_requested_dog_owner",
    email_store_purchase_kennel_club: "email_store_purchase_kennel_club",
    email_store_purchase_dog_owner: "email_store_purchase_dog_owner",

    email_new_course_registration_dog_owner:
      "email_new_course_registration_dog_owner",
    email_new_course_registration_kennel_club:
      "email_new_course_registration_kennel_club",
    email_approving_proposed_changes: "email_approving_proposed_changes",
    email_user_donation: "email_user_donation",

    email_favorite_club_new_event: "email_favorite_club_new_event",
    email_favorite_club_event_opens_3days: "email_favorite_club_event_opens_3days",
    email_favorite_club_event_opens_today: "email_favorite_club_event_opens_today",

    email_direct_message: "email_direct_message",

    email_event_change_dates: "email_event_change_dates",
    email_course_change_dates: "email_course_change_dates",
    email_payment_request_dog_owner: "email_payment_request_dog_owner",
    email_vaccine_cert_expire: "email_vaccine_cert_expire",
    email_waitlist_auto_charged: "email_waitlist_auto_charged",
    email_auto_payment_failed: "email_auto_payment_failed",
    email_bank_payment_failed: "email_bank_payment_failed",
  },

  notification_transport_type: {
    email: "email",
    sms: "sms",
  },

  // User Wallet & Points
  wallet: {
    points_to_dollar_ratio: 1000, // 1000 points = $1 USD
  },

  wallet_transaction_type: {
    earn: "earn",
    redeem: "redeem",
    adjustment: "adjustment",
  },

  wallet_transaction_source: {
    volunteer_hours: "volunteer_hours",
    course_session_credit: "course_session_credit",
  },

  wallet_transaction_object_type: {
    event: "event",
    course: "course",
  },

  object_type: {
    club: "club",
    dog: "dog",
    event: "event",
    system: "system",
    course: "course",
  },

  registration_number_type: {
    ukc_registered: "D",
    ukc_temporary: "TL",
    ukc_performance: "PL",
    ukc_permanent: "Permanent Reg.",
    ukc_performance_pl: "PL/LP",

    akc_registered: "AKC",
    akc_pal: "PAL/ILP",
    akc_canine_partner: "Canine Partner",
    akc_foreign_reg: "F. REG",

    ckc_registered: "CKC",
    ckc_ws: "WS",
    ckc_msc: "MSC",
    ckc_ern: "ERN",
    ckc_ccn: "CCN",
    ckc_pen: "PEN",
    ckc_tcn: "TCN",

    abi_registered: "ABI",
    abi_ukc: "UKC",
    abi_akc: "AKC",
    abi_ckc: "CKC",
    abi_other: "Other",

    isws_registered: "ISWS",
    isws_ukc: "UKC",
    isws_akc: "AKC",
    isws_ckc: "CKC",

    barn_hunt: "BH",
    asfa_registered: "ASFA",
    isws_other: "Other",

    ahba_registered: "AHBA",
  },

  object_permissions: {
    manage: "manage",
    read: "read",
    bulk_discount_admin: "bulk_discount_admin",
  },

  event_status: {
    draft: "draft",
    published: "published",
    upcoming: "upcoming",
    in_progress: "in_progress",
    complete: "complete",
    archived: "archived",
  },

  course_status: {
    draft: "draft",
    published: "published",
    upcoming: "upcoming",
    in_progress: "in_progress",
    complete: "complete",
    archived: "archived",
  },

  course_type: {
    full_course: "full_course",
    drop_in: "drop_in",
    seminar: "seminar",
  },

  course_category: {
    nosework:          "nosework",
    rally_obedience:   "rally_obedience",
    conformation:      "conformation",
    obedience:         "obedience",
    dock_diving:       "dock_diving",
    barn_hunt:         "barn_hunt",
    agility:           "agility",
    behaviour:         "behaviour",
    tracking:          "tracking",
    herding:           "herding",
    lure_coursing:     "lure_coursing",
    tricks:            "tricks",
    sport_foundations: "sport_foundations",
    handling:          "handling",
    health_wellness:   "health_wellness",
    other:             "other",
  },

  course_session_attendance_status: {
    //
    pending: "pending",
    absent: "absent",
    present: "present",
  },

  transaction_status: {
    pending: "pending",
    processing: "processing",
    success: "success",
    failed: "failed",
    unpaid: "unpaid",
    cancelled: "cancelled",
    payment_requested: "payment_requested",
    // Card/bank chargeback opened; funds are typically withdrawn or held.
    disputed: "disputed",
    // Dispute closed against the club (lost or refunded to close it).
    dispute_lost: "dispute_lost",
  },

  armband_generation: {
    for_event: "Per Entire Event",
    for_show: "Per Show Type",
  },

  armband_order_type: {
    registration_order: "Registration Order",
    breed_group_order: "Breed Group Order",
  },

  // AKC breed group order
  akc_breed_group_order: [
    "Sporting",
    "Hound",
    "Working",
    "Terrier",
    "Toy",
    "Non-Sporting",
    "Herding",
    "Miscellaneous",
    "AKC Foundation Stock Service (FSS)",
  ],

  // UKC Breed Group order (for armband sorting)
  ukc_breed_group_order: [
    "Guardian",
    "Scenthound",
    "Sighthound & Pariah Dog",
    "Gun Dog",
    "Northern Breed",
    "Herding Dogs",
    "Terrier Breeds",
    "Companion Dogs",
  ],

  // CDSP Video Trial Constants
  cdsp_elements: ["Starter Novice", "Novice", "Open", "Utility", "Versatility"],

  cdsp_levels: {
    a: "A",
    b: "B",
    c: "C",
  },

  cdsp_passing_score: 185, // Out of 200

  cdsp_result_status: {
    pass: "Pass",
    fail: "Fail",
  },

  sanctioning_club: {
    UKC: "UKC",
    AKC: "AKC",
    ABI: "ABI",
    CKC: "CKC",
    PWDCA: "PWDCA",
    CDSP: "CDSP",
    ISWS: "ISWS",
    BHA: "BHA",
    ASFA: "ASFA",
    NASDA: "NASDA",
    GCR: "GCR",
    CPE: "CPE",
    GENERAL: "General",
    C_WAGS: "C-Wags",
    FH: "4-H",
    AHBA: "AHBA",
    other: "Other",
  },

  // Array for UI components that need all sanctioning clubs
  // sanctioning_clubs_list: [
  //   "AKC", "UKC", "CKC", "ABI", "PWDCA", "ISWS", "BHA", "NASDA"
  // ],

  show_name: {
    trial_1: "Trial 1",
    trial_2: "Trial 2",
    trial_3: "Trial 3",
    trial_4: "Trial 4",
    // Trials 5-8 are offered to C-WAGS shows only (multi-trial weekends)
    trial_5: "Trial 5",
    trial_6: "Trial 6",
    trial_7: "Trial 7",
    trial_8: "Trial 8",
    show_1: "Show 1",
    show_2: "Show 2",
    show_3: "Show 3",
    show_4: "Show 4",
    test_1: "Test 1",
    test_2: "Test 2",
    test_3: "Test 3",
    test_4: "Test 4",
    pull_1: "Pull 1",
    pull_2: "Pull 2",
    fun_day: "Fun Day",
  },

  show_type: {
    conformation: "Conformation",
    nosework: "Nosework",
    sniff_n_go: "Sniff-n-Go",
    //performance: "Performance",
    obedience: "Obedience",
    rally_obedience: "Rally Obedience",
    scent_detection: "Scent Detection", // CKC
    agility: "Agility",
    weight_pull: "Weight Pull",
    urban_rat_race: "Urban Rat Race",
    country_rat_race: "Country Rat Race",
    scent_dog_games: "Scent Dog Games",
    lost_and_found: "Lost and Found",
    scentwork: "Scentwork",
    scent: "Scent",

    fast_cat: "Fast CAT",
    fast_dash: "Fast Dash",
    cat: "CAT",
    fetch: "Fetch",
    lure_coursing: "Lure Coursing",
    precision_coursing: "Precision Coursing",
    dock_jumping: "Dock Jumping",
    dock_diving: "Dock Diving",

    // CDSP Video Trial
    cdsp_video: "CDSP Video",

    shed_dog: "Shed Dog",
    water_dog: "Water Dog",
    farm_dog: "Farm Dog",
    att: "Temperament Test (ATT)",
    canine_good_citizen: "Canine Good Citizen",
    trick_dog: "Trick Dog",
    herding: "Herding",
    pre_trial_herding: "Pre-Trial (Herding)",
    instinct_test_herding: "Instinct Test (Herding)",
    barn_hunt: "Barn Hunt",
    on_leash_run_through: "On Leash Run Through",
    obedience_show_n_go: "Obedience Show N Go",
    general_rally: "Rally Show N Go",
    field_trial: "Field Trial",

    // Title Tracker - UKC specific show types
    ukc_obedience: "UKC Obedience",
    ukc_rally: "UKC Rally",

    // CPE show types
    speedway: "Speedway",
    nitrous_50: "Nitrous 50",
    nitrous_100: "Nitrous 100",

    // C-WAGS Games (Colors, Black Jack, Pairs, Team, Grab Bag) — one show type,
    // game = element, Level 1-4 / Zoom = level, no sections.
    cwags_games: "Games",
  },

  show_run_time_status: {
    available: "available",
    pending: "pending",
    reserved: "reserved",
  },

  account_type: {
    custom: "custom",
    standard: "standard",
  },

  dog_sex: {
    male: "Male",
    female: "Female",
  },

  nq_reason: {
    incorrect_call: "Incorrect Call by Handler",
    false_alert: "False Alert by Dog",
    timed_out: "Timed Out",
    exposed_hide: "Exposed Hide or Distraction Prior to Alert",
    miss: "Miss of Non-indication",
    too_many_faults: "Too Many Faults",
    handler_error: "Handler Error",
  },

  scentwork_nq_reason: {
    incorrect_alert_finish_call: "Incorrect Alert/Finish call",
    harsh_correction: "Harsh correction",
    significant_disruption_of_area: "Significant disruption of area",
    handler_unable_to_point_to_hide: "Handler unable to point to hide",
    max_time_exceeded: "Max time exceeded",
  },

  scentwork_excused_reason: {
    dog_eliminated_in_search_area: "Dog eliminated in search area",
    dog_overly_stressed: "Dog overly stressed",
    handler_request: "Handler Request",
    other: "Other",
  },

  scentwork_fault_type: {
    handler_error: "Handler Error",
    safety_concern: "Safety Concern",
    mild_disruption_of_area: "Mild Disruption of Area",
  },

  dog_registration_status: {
    pending: "pending",
    active: "active",
  },

  dog_class_section: {
    none: "None",
    nosework_a: "A",
    nosework_b: "B",
    // UKC Rally Obedience: A/B/C under RO1, A/B under RO2/RO3/ROM
    ukc_rally_a: "A",
    ukc_rally_b: "B",
    ukc_rally_c: "C",
    barn_hunt_a: "A",
    barn_hunt_b: "B",
    on_leash: "On Leashed",
    unleashed: "Off Leashed",
    // unleashed: "Unleashed",

    // AKC Herding Stock
    sheep: "Sheep",
    cattle: "Cattle",
    ducks: "Ducks",

    // AHBA Herding Stock (additional stock types)
    goats: "Goats",
    geese: "Geese",
    turkeys: "Turkeys",
    mixed_stock: "Mixed Stock",

    // Numeric sections for shows that allow multiple entries of same level (e.g., On Leash Run Through)
    section_1: "1",
    section_2: "2",
    section_3: "3",
    section_4: "4",
    section_5: "5",
    section_6: "6",
    section_7: "7",
    section_8: "8",
    section_9: "9",
    section_10: "10",

    // C-WAGS Obedience sections
    cwags_obedience_a: "A",
    cwags_obedience_b: "B",
    cwags_obedience_to: "TO",
    cwags_obedience_jr: "JR",

    // C-WAGS Rally sections (same as Obedience)
    cwags_rally_a: "A",
    cwags_rally_b: "B",
    cwags_rally_to: "TO",
    cwags_rally_jr: "JR",

    // FEO — For Exhibition Only (all four C-WAGS show types). Obedience / Rally offer it
    // per level in show setup like A/B/TO/JR; Scent / Games offer it show-wide via
    // show.feo_available. Priced with the flat show.feo_fee. Never counts for qualifying.
    feo: "FEO",

    // ABI Scent Dog Games sections
    sdg_level_1: "Level 1",
    sdg_level_2: "Level 2",

    // 4-H Agility divisions
    fh_agility_division_a: "Division A",
    fh_agility_division_b: "Division B",
  },

  dog_class_element: {
    nosework_container: "Container",
    nosework_exterior: "Exterior",
    nosework_interior: "Interior",
    nosework_vehicle: "Vehicle",
    nosework_handler_descrimination: "Handler Disc.",

    barn_hunt: "Barn Hunt",
    barn_hunt_instinct: "Instinct",
    barn_hunt_novice: "Novice",
    barn_hunt_open: "Open",
    barn_hunt_senior: "Senior",
    barn_hunt_master: "Master",
    barn_hunt_crazy_8s: "Crazy 8s",
    barn_hunt_line_drive: "Line Drive",

    on_leash_run_through: "On Leash Run Through",
    asfa_stakes: "Stakes",
    asfa_additional_stakes: "Additional Stakes",

    conformation: "Conformation",
    conformation_altered: "Altered Conformation",
    conformation_non_licensed: "Non-Licensed Classes",
    conformation_special_classes: "Special Classes",
    conformation_non_regular: "Non-Regular Classes",
    conformation_sweepstakes: "Sweepstakes",
    conformation_junior: "Junior Handler/Showmanship",

    // CDSP Video Elements
    cdsp_starter_novice: "Starter Novice",
    cdsp_novice: "Novice",
    cdsp_open: "Open",
    cdsp_utility: "Utility",
    cdsp_versatility: "Versatility",

    novice_puppy: "Novice Puppy",
    veteran: "Veteran",
    brood_bitch_stud_dog: "Brood Bitch/Stud Dog",
    brace: "Brace",
    total_dog: "Total Dog",
    total_junior: "Total Junior",
    other: "Other",
    other_racing_bred_dogs: "Other: Racing Bred Dogs",

    dock_jumping_air: "Air",
    dock_jumping_vertical: "Vertical",
    dock_jumping_fetch_it: "Fetch It",
    dock_jumping_raider_run: "Raider Run",
    //dock_jumping: "Dock Jumping",
    dock_diving: "Dock Diving",

    abi_best_of_breed: "Best of Breed",
    abi_bred_by_exibitor: "Bred by Exibitor",
    abi_stud_dog: "Stud Dog",
    abi_brood_bitch: "Brood Bitch",
    abi_star: "STAR Testing",
    abi_canadian_bred_bis: "Canadian Bred BIS", // Updated label
    abi_canadian_bred_bis_legacy: "Canadian Bred by BIS", // Keep for backward compatibility with existing registrations
    abi_bred_by_bis: "Bred by BIS",
    abi_show_of_shows: "Show of Shows",

    isws_best_of_breed: "Best of Breed",
    isws_bred_by_exibitor: "Bred by Exibitor",
    isws_stud_dog: "Stud Dog",
    isws_brood_bitch: "Brood Bitch",

    // Deprecated: use akc_puppy_sweepstakes instead
    akc_sweepstakes: "Sweepstakes", // DEPRECATED
    // Deprecated: use akc_18_24_month_puppy instead
    akc_12_24_month_puppy: "12-24 Month Puppy", // DEPRECATED
    // Deprecated: use akc_dual_title_sweepstakes_6m_7y and akc_dual_title_sweepstakes_7y_plus instead
    akc_dual_title_sweepstakes: "Dual-Title Sweepstakes", // DEPRECATED

    performance_rally_obedience: "Rally Obedience",
    performance_obedience: "Obedience",
    performance_non_licensed_obedience: "Non-Licensed Obedience",
    obedience_unofficial: "Unofficial Classes", // CKC Obedience, Chapter 16
    rally_unofficial: "Unofficial Rally Classes", // CKC Rally Obedience, Chapter 19
    pairs: "Pairs",
    precision_heeling: "Precision Heeling",
    team: "Team",
    versatility: "Versatility",
    performance_weight_pull: "Weight Pull",
    weight_pull_wheels_natural: "Wheels Natural",
    weight_pull_wheels_artificial: "Wheels Artificial",
    weight_pull_snow: "Snow",
    weight_pull_rail: "Rail",
    performance_urban_rat_race: "Urban Rat Race",
    performance_country_rat_race: "Country Rat Race",
    performance_scent_dog_games: "Scent Dog Games",
    performance_lost_and_found: "Lost and Found",
    sdg_once_around: "Once Around",
    sdg_double_or_nothing: "Double or Nothing",
    sdg_clear_it: "Clear It",
    sdg_duo: "Duo",
    sdg_teams: "Teams",
    sdg_against_odds: "Against Odds",
    sdg_hi_lo: "Hi Lo",
    sdg_double_0_7: "Super 7",
    sdg_at_distance: "At Distance",
    sdg_relay_race: "Relay Race",
    sdg_cluster: "Cluster",
    sdg_hit_the_wall: "Hit the Wall",
    sdg_twice_around_foundations: "Twice Around: FNDS",
    sdg_clear_it_foundations: "Clear It: FNDS",
    sdg_cluster_foundations: "Cluster: FNDS",
    sdg_hi_lo_foundations: "Hi Lo: FNDS",
    sdg_hit_the_wall_foundations: "Hit the Wall: FNDS",

    scentwork_container: "Container",
    scentwork_interior: "Interior",
    scentwork_exterior: "Exterior",
    scentwork_buried: "Buried",
    scentwork_handler_disc: "Handler Discrimination",
    scentwork_detective: "Detective",

    // CKC Scent Detection components (Scent Detection Rules 6.8.2)
    scent_detection_container: "Container",
    scent_detection_interior: "Interior",
    scent_detection_exterior: "Exterior",

    tubes: "Tubes",
    unobstructed: "Unobstructed",
    obstructed: "Obstructed",
    obstructed_2: "Obstructed 2",
    games: "Games",

    lf_containers: "Containers",
    lf_interiors: "Interiors",
    lf_exteriors: "Exteriors",

    beginner_a: "Beginner A",
    beginner_b: "Beginner B",
    intermediate_a: "Intermediate A",
    intermediate_b: "Intermediate B",
    excellent: "Excellent",

    fast_cat: "Fast CAT",
    fast_dash: "Fast Dash",
    cat: "CAT",
    fetch: "Fetch",

    // AKC Farm Dog
    farm_dog: "Farm Dog",

    // AKC ATT
    att: "Temperament Test (ATT)",

    //UKC/AKC junior showmanship
    junior_showmanship: "Junior Showmanship",

    //UKC, AKC Lure Coursing
    lure_coursing: "Lure Coursing",

    // UKC
    precision_coursing: "Precision Coursing",
    pc_division: "PC Division",

    // UKC Shed Dog
    shed_dog: "Shed Dog",
    // working_shed_dog: "Working Shed Dog",
    // shed_dog_champion: "Champion",
    // shed_dog_youth: "Youth",

    // UKC Agility
    agility: "Agility",
    performance_agility: "Agility",
    agility_dynamic: "Dynamic Classes",

    // UKC Agility Divisions
    agility_division_toy: "Toy",
    agility_division_1: "Division 1",
    agility_division_2: "Division 2",
    agility_division_3: "Division 3",

    // 4-H Agility elements
    fh_agility_jtt:                           "Jumps, Tunnels and Table (JTT)",
    fh_agility_standard_no_weaves:            "Standard without Weaves",
    fh_agility_standard_with_weaves:          "Standard with Weaves",
    fh_agility_advanced_standard_with_weaves: "Advanced Standard with Weaves",
    fh_agility_advanced_jumpers_no_weaves:    "Advanced Jumpers without Weaves",

    // PWDCA Water dog
    water_dog: "Water Dog",
    junior_water_dog: "Junior",
    apprentice: "Apprentice",
    working: "Working",
    courier: "Courier",
    master: "Master",

    cgc: "Canine Good Citizen",
    canine_good_citizen: "CGC",
    canine_good_citizen_advanced: "CGCA",
    canine_good_citizen_urban: "CGCU",

    trick_dog: "Trick Dog",

    // AKC Herding
    course_a: "Course A",
    course_b: "Course B",
    course_c: "Course C",
    course_d: "Course D",
    pre_trial_herding: "Pre-Trial (Herding)",
    instinct_test_herding: "Instinct Test (Herding)",

    // AHBA Herding
    ahba_htd: "HTD",
    ahba_htad: "HTAD",
    ahba_hrd: "HRD",
    ahba_rlf: "RLF",
    ahba_btd: "BTD",
    ahba_jhd: "JHD",
    ahba_hct: "HCT",

    // CPE show elements
    speedway: "Speedway",

    // GCR show elements
    nitrous_50: "Nitrous 50",
    nitrous_100: "Nitrous 100",

    // General sanctioning club show elements
    sniff_n_go: "Sniff-n-Go",
    // Obedience Show N Go levels (used as show_element in flat show type)
    obedience_show_n_go_beginner_novice: "Beginner Novice",
    // General Rally levels (used as show_element in flat show type)
    general_rally_intermediate: "Intermediate",
    general_rally_advanced: "Advanced",
    general_rally_choice: "Choice",

    // C-Wags sanctioning club show elements
    scent: "Scent",
    ranger: "Ranger",
    dasher: "Dasher",

    // C-WAGS Games elements (the individual games). "Pairs"/"Team" display
    // strings also exist for UKC non-licensed obedience (dog_class_element.pairs /
    // .team and *_level.pairs / .team) — any logic keyed on these must also be
    // gated on sanctioning club C-Wags + show_type Games.
    cwags_games_colors: "Colors",
    cwags_games_black_jack: "Black Jack",
    cwags_games_pairs: "Pairs",
    cwags_games_team: "Team",
    cwags_games_grab_bag: "Grab Bag",

    // AKC Agility
    standard: "Standard",
    jumpers_with_weaves: "Jumpers With Weaves (JWW)",
    fast: "FAST (Fifteen and Send Time)",
    t2b: "Time 2 Beat",
    premier_standard: "Premier standard",
    premier_jww: "Premier JWW",
  },

  dog_class_element_level: {
    // nosework
    novice: "Novice",
    advanced: "Advanced",
    superior: "Superior",
    master: "Master",
    elite: "Elite",
    excellent: "Excellent",

    // Barn Hunt (BHA) - Regular Classes
    barn_hunt_instinct: "Instinct",
    barn_hunt_novice: "Novice",
    barn_hunt_open: "Open",
    barn_hunt_senior: "Senior",
    barn_hunt_master: "Master",

    // Barn Hunt (BHA) - Special Formats
    barn_hunt_crazy_8s: "Crazy 8s",
    barn_hunt_line_drive: "Line Drive",

    // CDSP Video Levels
    cdsp_level_a: "A",
    cdsp_level_b: "B",
    cdsp_level_c: "C",

    // On Leash Run Through
    on_leash_run_through_novice: "Novice",
    on_leash_run_through_intermediate: "Intermediate",

    // Obedience Show N Go
    obedience_show_n_go_beginner_novice: "Beginner Novice",
    obedience_show_n_go_novice: "Novice",
    obedience_show_n_go_open: "Open",
    obedience_show_n_go_utility: "Utility",

    // General Rally
    general_rally_novice: "Novice",
    general_rally_intermediate: "Intermediate",
    general_rally_advanced: "Advanced",
    general_rally_excellent: "Excellent",
    general_rally_master: "Master",
    general_rally_choice: "Choice",

    // ASFA Field Trial - Stakes
    asfa_open: "Open",
    asfa_fch: "FCH",
    asfa_veteran: "Veteran",
    asfa_singles: "Singles",
    asfa_provisional: "Provisional",
    // ASFA Field Trial - Additional Stakes
    asfa_kennel: "Kennel",
    asfa_breeder: "Breeder",
    asfa_bench: "Bench",

    // sniff-n-go
    one_hide_birch: "One Hide Per Search (Birch)",
    two_hides_birch_anise: "Two Hides Per Search (Birch & Anise)",
    three_hides_birch_anise_clove:
      "Three Hides Per Search (Birch, Anise or Clove)",
    new_to_nosework: "New to Nosework",

    // C-Wags Scent levels
    patrols_1: "Patrol 1",
    detective_2: "Detective 2",
    investigator_3: "Investigator 3",
    super_sleuth_4: "Super Sleuth 4",
    private_investigator: "Private Inv",
    detective_diversions: "Det Diversions",
    scent_ranger_1: "Ranger 1",
    scent_ranger_2: "Ranger 2",
    scent_ranger_3: "Ranger 3",
    scent_ranger_4: "Ranger 4",
    scent_ranger_5: "Ranger 5",
    dasher_scent_3: "Dasher 3",
    dasher_scent_4: "Dasher 4",
    dasher_scent_5: "Dasher 5",
    dasher_scent_6: "Dasher 6",

    // C-Wags Obedience levels
    cwags_obedience_level_1: "Level 1",
    cwags_obedience_level_2: "Level 2",
    cwags_obedience_level_3: "Level 3",
    cwags_obedience_level_4: "Level 4",
    cwags_obedience_level_5: "Level 5",

    // C-WAGS Rally levels
    cwags_rally_starter: "Starter",
    cwags_rally_advanced: "Advanced",
    cwags_rally_pro: "Pro",
    cwags_rally_zoom_1: "Zoom 1",
    cwags_rally_zoom_1_5: "Zoom 1.5",
    cwags_rally_zoom_2: "Zoom 2",
    cwags_rally_arf: "ARF",

    // C-WAGS Games levels. Level 1-4 map to the Starter / Advanced / Pro / ARF
    // rally exercise sets; Zoom 1 / 1.5 / 2 are the Zoom variants of the game
    // (the rulebook calls them "Zoom Level 1/2/3" but defines them by the Rally
    // Zoom class, so we label them the way C-WAGS Rally already does here).
    cwags_games_level_1: "Level 1",
    cwags_games_level_2: "Level 2",
    cwags_games_level_3: "Level 3",
    cwags_games_level_4: "Level 4",
    cwags_games_zoom_1: "Zoom 1",
    cwags_games_zoom_1_5: "Zoom 1.5",
    cwags_games_zoom_2: "Zoom 2",

    // 4-H Rally Obedience levels
    fh_rally_foundation_3_7:    "Foundation (Grade 3-7)",
    fh_rally_foundation_8_up:   "Foundation (Grade 8 & Up)",
    fh_rally_novice_3_7:        "Novice (Grade 3-7)",
    fh_rally_novice_8_up:       "Novice (Grade 8 & Up)",
    fh_rally_intermediate_3_7:  "Intermediate (Grade 3-7)",
    fh_rally_intermediate_8_up: "Intermediate (Grade 8 & Up)",
    fh_rally_advanced_3_7:      "Advanced (Grade 3-7)",
    fh_rally_advanced_8_up:     "Advanced (Grade 8 & Up)",
    fh_rally_excellent:         "Excellent",
    fh_rally_masters:           "Masters",

    // 4-H Agility levels (On-Leash / Off-Leash)
    fh_agility_on_leash:  "On-Leash",
    fh_agility_off_leash: "Off-Leash",

    //Conformation (UKC) - breed awards
    winners_male: "WM",
    reserve_winners_male: "RWM",
    winners_female: "WF",
    reserve_winners_female: "RWF",
    best_of_breed: "BOB",
    best_of_opposite_sex: "BOOS",

    //Conformation (UKC)
    puppy: "Puppy (6 months-under 1 year)",
    junior: "Junior (1 year-under 2 years)",
    adult: "Adult (2 years & over)",
    open: "Open (6 months & over)",
    breader_handler: "Breeder & Handler (6 months & over shown by breeder)",
    champion: "Champion (CH)",
    grand_champion: "Grand Champion (GRCH)",

    // Conformation (UKC) - non-licensed classes
    novice_puppy: "Novice Puppy",
    veteran: "Veteran",
    brood_bitch_stud_dog: "Brood Bitch/Stud Dog",
    brace: "Brace",
    total_dog: "Total Dog",
    other: "Other",
    other_racing_bred_dogs: "Other: Racing Bred Dogs",

    //Conformation (AKC) - regular classes
    akc_4_6_month_puppy: "4-6 Month Puppy",
    akc_4_6_month_puppy_exhibitor_only: "4-6 Month Puppy (Exhibitor Only)",
    akc_6_9_month_puppy: "6-9 Month Puppy",
    akc_9_12_month_puppy: "9-12 Month Puppy",
    akc_12_15_month_puppy: "12-15 Month Puppy",
    akc_15_18_month_puppy: "15-18 Month Puppy",
    akc_12_18_month_puppy: "12-18 Month Puppy",
    akc_18_24_month_puppy: "18-24 Month Puppy",
    //akc_12_18_month_puppy: "12-18 Month Puppy",
    //akc_novice_or_amateur_handler: "Novice or Amateur-Owner-Handler",
    akc_under_12_month_bred_by_exhibitor: "Under 12 Month Bred-by-Exhibitor",
    akc_adult_bred_by_exhibitor: "Adult Bred-by-Exhibitor",
    akc_amateur_owner_handler: "Amateur-Owner-Handler",
    akc_american_bred: "American Bred",
    akc_open: "Open",
    akc_exhibition_only: "Exhibition Only",
    akc_novice: "Novice",
    akc_miscellaneous: "Miscellaneous",
    akc_best_of_breed: "Best of Breed",
    akc_brood_bitch: "Brood Bitch",
    akc_stud_dog: "Stud Dog",
    akc_brace: "Brace",

    akc_veteran_8_10_years: "Veteran (8-10 years)",
    akc_veteran_8_11_years: "Veteran (8-11 years)",
    akc_veteran_10_12_years: "Veteran (10-12 years)",
    akc_veteran_11_plus_years: "Veteran (11+ years)",
    akc_veteran_13_plus_years: "Veteran (13+ years)",
    akc_veteran_8_plus_years: "Veteran (8+ years)",
    akc_veteran_10_plus_years: "Veteran (10+ years)",
    akc_veteran_7_plus_years: "Veteran (7+ years)",
    akc_veteran_6_8_years: "Veteran (6-8 years)",
    akc_veteran_6_plus_years: "Veteran (6 & Over)",
    akc_veteran_7_10_years: "Veteran (7-10 years)",
    akc_veteran_7_9_years: "Veteran (7-9 years)",
    akc_veteran_9_plus_years: "Veteran (9+ years)",
    akc_veteran_12_plus_years: "Veteran (12+ years)",

    //Conformation (AKC) - non-regular classes
    //This will have to be changed to accomadate sublevels
    akc_puppy_sweepstakes: "Puppy Sweepstakes", // DEPRECATED - use age-specific classes instead
    akc_puppy_sweepstakes_6_9: "Puppy Sweepstakes (6-9 months)",
    akc_puppy_sweepstakes_9_12: "Puppy Sweepstakes (9-12 months)",
    akc_puppy_sweepstakes_12_18: "Puppy Sweepstakes (12-18 months)",
    akc_puppy_sweepstakes_12_15: "Puppy Sweepstakes (12-15 months)",
    akc_puppy_sweepstakes_15_18: "Puppy Sweepstakes (15-18 months)",
    akc_puppy_sweepstakes_bred_by_exhibitor_6_18:
      "Puppy Sweepstakes, Bred-by-Exhibitor (6-18 months)",
    akc_puppy_sweepstakes_18_24: "Puppy Sweepstakes (18-24 months)",
    akc_veteran_sweepstakes_7_9: "Veteran Sweepstakes (7-9 years)",
    akc_veteran_sweepstakes_7_10: "Veteran Sweepstakes (7-10 years)",
    akc_veteran_sweepstakes_8_10: "Veteran Sweepstakes (8-10 years)",
    akc_veteran_sweepstakes_8_11: "Veteran Sweepstakes (8-11 years)",
    akc_veteran_sweepstakes_9_plus: "Veteran Sweepstakes (9+ years)",
    akc_veteran_sweepstakes_10_12: "Veteran Sweepstakes (10-12 years)",
    akc_veteran_sweepstakes_11_plus: "Veteran Sweepstakes (11+ years)",
    akc_veteran_sweepstakes_10_13: "Veteran Sweepstakes (10-13 years)",
    akc_veteran_sweepstakes_10_plus: "Veteran Sweepstakes (10+ years)",
    akc_veteran_sweepstakes_12_plus: "Veteran Sweepstakes (12+ years)",
    akc_veteran_sweepstakes_13_plus: "Veteran Sweepstakes (13+ years)",
    akc_dual_title_sweepstakes_6m_7y:
      "Dual-Titled Sweepstakes (6 months - 7 years)",
    akc_dual_title_sweepstakes_7y_plus: "Dual-Titled Sweepstakes (7-10 years)",
    akc_dual_title_sweepstakes_7y_11y: "Dual-Titled Sweepstakes (7-11 years)",
    akc_dual_title_sweepstakes_10y_plus: "Dual-Titled Sweepstakes (10+ years)",
    akc_dual_title_sweepstakes_11y_plus: "Dual-Titled Sweepstakes (11+ years)",
    akc_futurity: "Futurity",
    akc_sled_dog: "Sled Dog",
    akc_hunting_class: "Hunting Class",
    akc_field_trial_class: "Field Trial Class",
    akc_teams: "Teams",
    akc_parade_of_titleholders: "Parade of Titleholders",
    akc_coursing: "Coursing",
    akc_best_head: "Best Head",
    akc_best_movement: "Best Movement",
    akc_best_field: "Best Field",
    akc_junior_showmanship: "JR. Showmanship", //TODO

    // performance - agility
    beginner_a: "Beginner A",
    beginner_b: "Beginner B",
    intermediate_a: "Intermediate A",
    intermediate_b: "Intermediate B",
    //excellent: "Excellent", //already exists

    // Agility - Dynamic Classes
    novice_hurdles: "Novice Hurdles",
    elite_hurdles: "Elite Hurdles",
    novice_tunnels: "Novice Tunnels",
    elite_tunnels: "Elite Tunnels",
    three_of_a_kind: "3 of a Kind",

    // Agility - Division
    // toy_10_inch_and_under: 'Toy (10" & Under)',
    // one_over_10_to_14_inch: '1 (over 10" - 14")',
    // two_over_14_to_20_inch: '2 (over 14" - 20")',
    // three_over_20_inch: '3 (over 20")',

    // Agility - Jump Height
    minimum_height: "Minimum Height",
    standard_height: "Standard Height",

    // Agility - weight pull
    division_a: "Division A",
    division_b: "Division B",
    // already exists
    //veteran: "Veteran",

    // performance - rally obedience (UKC)
    // Canonical form: level RO1/RO2/RO3/ROM with dog_class.section A/B/C.
    // See ukc-rally-classes.ts. The "RO1 A" style values below are the legacy
    // single-string form still present on older shows and scores.
    ro1: "RO1",
    ro2: "RO2",
    ro3: "RO3",
    rom: "ROM",

    ro1_a: "RO1 A",
    ro1_b: "RO1 B",
    ro1_c: "RO1 C",

    ro2_a: "RO2 A",
    ro2_b: "RO2 B",

    ro3_a: "RO3 A",
    ro3_b: "RO3 B",

    rom_a: "ROM A",
    rom_b: "ROM B",

    rae: "RAE",
    raem: "RAEM", // Legacy value for backward compatibility
    rach: "RACH", // New preferred value
    urx: "URX, UROC & UROG", // UKC
    rmx: "RMX, RMC & RMG", // UKC
    // UKC Agility multi-entries. `grach` runs the B levels (Beginner B +
    // Intermediate B + Excellent), `grach_a` runs the A levels (Beginner A +
    // Intermediate A + Excellent) and `ach` runs Beginner B + Intermediate B.
    // `grach_b` is a legacy value kept so existing shows, registrations and
    // scores keep resolving. Do not offer it for new shows.
    ach: "ACH", // UKC
    grach: "GRACH", // UKC
    grach_a: "GRACH A", // UKC
    grach_b: "GRACH B", // UKC — legacy, same behaviour as GRACH
    random_draw_novice: "Random Reward Novice", // AKC Obedience
    random_draw_open: "Random Reward Open", // AKC Obedience
    random_reward_utility: "Random Reward Utility", // AKC Obedience

    // performance - obedience
    pre_novice: "Pre-Novice", // UKC
    beginner_novice: "Beginner Novice", // UKC
    beginner_novice_a: "Beginner Novice A", // AKC
    beginner_novice_b: "Beginner Novice B", // AKC
    preferred_novice: "Preferred Novice", // AKC
    novice_a: "Novice A", // UKC, AKC
    novice_b: "Novice B", // UKC, AKC
    novice_c: "Novice C", // UKC
    advance_novice: "Advance Novice", // UKC
    graduate_novice: "Graduate Novice", // AKC
    open_a: "Open A", // UKC, AKC
    open_b: "Open B", // UKC, AKC
    advance_open: "Advance Open", // UKC
    preferred_open: "Preferred Open", // AKC
    graduate_open: "Graduate Open", // AKC
    preferred_graduate_open: "Preferred Graduate Open", // AKC
    utility_a: "Utility A", // UKC, AKC
    utility_b: "Utility B", // UKC, AKC
    preferred_utility: "Preferred Utility", // AKC
    wc_novice: "Wild Card Novice",
    wc_open: "Wild Card Open",
    wc_utility: "Wild Card Utility",
    udx: "UDX",
    uudx: "UUDX, UOCH & GOCH", // UKC

    // master: "Master",
    // elite: "Elite",
    //veteran: "Veteran",

    // performance - non-licensed obedience
    //brace: "Brace",pakc-
    pairs: "Pairs",
    novice_pairs: "Pairs - Novice",
    advanced_pairs: "Pairs - Advanced",
    excellent_pairs: "Pairs - Excellent",
    precision_heeling: "Precision Heeling",
    team: "Team",
    novice_teams: "Teams - Novice",
    advanced_teams: "Teams - Advanced",
    versatility: "Versatility", // AKC performance as well
    //veteran: "Veteran",

    //ABI Other
    abi_star: "STAR Testing",
    abi_canadian_bred_bis: "Canadian Bred BIS", // Updated label
    abi_canadian_bred_bis_legacy: "Canadian Bred by BIS", // Keep for backward compatibility with existing registrations
    abi_bred_by_bis: "Bred by BIS",
    abi_show_of_shows: "Show of Shows",

    // ABI Conformation - Main show elements (also used as levels)
    abi_conformation: "Conformation",
    abi_conformation_altered: "Altered Conformation",
    abi_conformation_non_licensed: "Non-Licensed Classes",

    // ABI Conformation
    abi_baby_puppy: "Baby Puppy",
    abi_6_9_months: "6 - 9 Month",
    abi_9_12_months: "9 - 12 Month",
    abi_12_18_months: "12 - 18 Month",
    abi_bred_by_exibitor: "Bred by Exibitor",
    abi_open: "Open",
    abi_best_of_breed: "Best of Breed",
    abi_brace: "Brace",
    abi_veteran: "Veteran",
    abi_altered: "Altered",
    abi_jr_champion: "Jr. Champion",
    abi_champion: "Champion",
    abi_master_champion: "Master Champion",
    abi_grand_champion: "Grand Champion",
    abi_supreme_champion: "Supreme Champion",
    abi_ultimate_champion: "Ultimate Champion",
    abi_royal_champion: "Royal Champion",
    abi_legendary_champion: "Legendary Champion",
    abi_stud_dog: "Stud Dog",
    abi_brood_bitch: "Brood Bitch",

    // ISWS Conformation - Regular Classes
    isws_puppy_6_12: "6-12 months puppy",
    isws_puppy_6_9: "6-9 months puppy",
    isws_puppy_9_12: "9-12 months puppy",
    isws_junior_puppy: "Junior puppy (6-9 months)",
    isws_senior_puppy: "Senior puppy (9-12 months)",
    isws_1218: "12-18 months",
    isws_novice: "Novice (6 months or older)",
    isws_canadian_bred: "Canadian bred",
    isws_american_bred: "American bred",
    isws_bred_by_exibitor: "Bred by exhibitor",
    isws_open: "Open (6 months or older)",
    isws_field_performance_champion: "Field Performance Champion",
    isws_performance_champion: "Performance champion",
    isws_champion: "Champion",

    // ISWS Conformation - Altered Classes
    isws_altered_novice: "Altered novice",
    isws_altered_open: "Altered open",
    isws_altered_champion: "Altered champion",

    // ISWS Conformation - Non-Regular Classes
    isws_puppy_3_6: "3-6 months puppy",
    isws_best_of_breed: "Best of Breed",
    isws_veteran: "Veterans (7 years and over)",
    isws_veteran_7_10: "Veterans 7-10 years",
    isws_veteran_10_plus: "Veterans 10 years and older",
    isws_veteran_10_13: "Veterans 10-13 years",
    isws_veteran_13_plus: "Veterans 13 years and older",

    // ISWS Conformation - Sweepstakes Classes
    isws_sweeps_puppy_3_6: "Puppy Sweepstakes 3-6 months",
    isws_sweeps_puppy_6_12: "Puppy Sweepstakes 6-12 months",
    isws_sweeps_12_24: "Sweepstakes 12-24 months",
    isws_sweeps_veteran_7_plus: "Veterans Sweepstakes 7+ years",
    isws_sweeps_veteran_7_10: "Veterans Sweepstakes 7-10 years",
    isws_sweeps_veteran_10_plus: "Veterans Sweepstakes 10+ years",
    isws_sweeps_veteran_7_9: "Veterans Sweepstakes 7-9 years",
    isws_sweeps_veteran_9_13: "Veterans Sweepstakes 9-13 years",
    isws_sweeps_veteran_13_plus: "Veterans Sweepstakes 13+ years",

    // ISWS Conformation - Junior Handler/Showmanship Classes
    isws_junior_handler_1: "Junior Handler 1 (2-4 years)",
    isws_junior_handler_2: "Junior Handler 2 (4-8 years)",
    isws_junior_showmanship_1: "Junior Showmanship 1 (8-12 years)",
    isws_junior_showmanship_2: "Junior Showmanship 2 (12-18 years)",

    // ISWS Conformation - Special Classes
    isws_brace: "Brace",
    isws_stud_dog: "Stud dog",
    isws_brood_bitch: "Brood bitch",

    // CKC Conformation - Regular classes (CKC Conformation Show Rules 12.2.1)
    ckc_junior_puppy: "Junior Puppy (6-9 months)",
    ckc_senior_puppy: "Senior Puppy (9-12 months)",
    ckc_12_18_month: "12-18 Month",
    ckc_canadian_bred: "Canadian Bred",
    ckc_bred_by_exhibitor: "Bred by Exhibitor",
    ckc_open: "Open",
    ckc_specials_only: "Specials Only",

    // CKC Conformation - Non-Regular classes (12.6.1)
    ckc_baby_puppy: "Baby Puppy (4-6 months)",
    ckc_veterans: "Veterans (7+ years)",
    ckc_exhibition_only: "Exhibition Only",

    // CKC Conformation - Special classes (12.6.1(c))
    ckc_brace: "Brace",

    // CKC Conformation - Sweepstakes (12.8.3)
    ckc_sweepstakes_4_6: "Sweepstakes 4-6 months",
    ckc_sweepstakes_6_9: "Sweepstakes 6-9 months",
    ckc_sweepstakes_9_12: "Sweepstakes 9-12 months",
    ckc_sweepstakes_12_18: "Sweepstakes 12-18 months",
    ckc_veterans_sweepstakes: "Veterans Sweepstakes (7+ years)",

    // CKC Conformation - Altered (Chapter 13)
    ckc_altered: "Altered",

    // CKC Obedience - official classes with no shared equivalent (Obedience Rules 11.1)
    ckc_novice_intermediate: "Novice Intermediate",
    // CKC Obedience - club-defined unofficial classes (premium list, 4.1.5)
    ckc_pre_open: "Pre-Open",
    ckc_pre_utility: "Pre-Utility",

    // CKC Scent Detection classes (Scent Detection Rules 6.8.1)
    scent_detection_instinct: "Instinct",
    scent_detection_novice: "Novice",
    scent_detection_open: "Open",
    scent_detection_excellent: "Excellent",
    scent_detection_master: "Master",

    // ABI performance - Country Rat Race
    cubs: "Cubs",
    scouts: "Scouts",
    huntsman: "Huntsman",
    huntsmaster: "Huntsmaster",
    field_master: "Field Master",

    // ABI performance - Urban Rat Race
    rookie: "Rookie",
    clever: "Clever",
    adventurer: "Adventurer",
    explorer: "Explorer",
    detective: "Detective",
    investigator: "Investigator",
    inspector: "Inspector",
    fantastic_five: "Fantastic Five",
    tempting_ten: "Tempting Ten",
    junkyard: "Junkyard",
    junkyard_ex: "Junkyard Ex.",
    tag_team: "Tag Team",

    // ABI performance - Lost and Found
    seeker: "Seeker",
    locater: "Locater",
    discover: "Discover",

    // ABI Scent Dog Games
    sdg_once_around: "Once Around",
    sdg_double_or_nothing: "Double or Nothing",
    sdg_clear_it: "Clear It",
    sdg_duo: "Duo",
    sdg_teams: "Teams",
    sdg_against_odds: "Against Odds",
    sdg_hi_lo: "Hi Lo",
    sdg_double_0_7: "Super 7",
    sdg_at_distance: "At Distance",
    sdg_relay_race: "Relay Race",
    sdg_cluster: "Cluster",
    sdg_hit_the_wall: "Hit the Wall",
    sdg_twice_around_foundations: "Twice Around: Foundations",
    sdg_clear_it_foundations: "Clear It: Foundations",
    sdg_cluster_foundations: "Cluster: Foundations",
    sdg_hi_lo_foundations: "Hi Lo: Foundations",
    sdg_hit_the_wall_foundations: "Hit the Wall: Foundations",

    fast_cat: "Fast CAT",
    fast_dash: "Fast Dash",
    cat: "CAT",

    // AKC Fetch
    //novice: "Novice"
    intermediate: "Intermediate",
    //advanced: "Advanced",
    retriever: "Retriever",

    // AKC Rally Obedience
    //novice_a: "Novice A",
    //novice_b: "Novice B",
    //intermediate: "Intermediate",
    advanced_a: "Advanced A",
    advanced_b: "Advanced B",
    excellent_a: "Excellent A",
    excellent_b: "Excellent B",
    //excellent: "Excellent",
    //master: "Master",
    choice: "Choice",

    // AKC Scentwork
    scentwork_novice_a: "Novice A",
    scentwork_novice_b: "Novice B",
    scentwork_advanced: "Advanced",
    scentwork_excellent: "Excellent",
    scentwork_master: "Master",
    scentwork_detective: "Detective",

    // AKC Farm Dog
    farm_dog: "Farm Dog",

    // AKC ATT
    att: "Temperament Test (ATT)",

    // General Dock Diving
    dock_diving: "Dock Diving",

    // UKC junior showmanship
    pee_wee: "Pee Wee (2 years-under 4 years)",
    sub_junior: "Sub JR (4 years-under 6 years)",
    pre_junior: "Pre-Junior (6 years-under 8 years)",
    novice_junior: "Novice Junior (8 years-under 13 years)",
    open_junior: "Open Junior (8 years-under 13 years)",
    novice_senior: "Novice Senior (13 years-18 years)",
    open_senior: "Open Senior (13 years-18 years)",
    total_junior: "Total Junior",

    // AKC junior showmanship
    akc_novice_junior: "Novice Junior (Ages 9-11)",
    akc_novice_intermediate: "Novice Intermediate (Ages 12-14)",
    akc_novice_senior: "Novice Senior (Ages 15-18)",
    akc_open_junior: "Open Junior (Ages 9-11)",
    akc_open_intermediate: "Open Intermediate (Ages 12-14)",
    akc_open_senior: "Open Senior (Ages 15-18)",
    akc_master_class: "Master Class (Ages 9-18, with requisite wins)",
    akc_junior_showmanship_novice: "JS - Novice",
    akc_junior_showmanship_open: "JS - Open",
    akc_junior_showmanship_master: "JS - Master",

    //AKC Lure Coursing
    //open: "Open",
    //veteran: "Veteran",
    special: "Special",
    junior_coursing: "Junior Coursing",
    qualified_coursing: "Qualified Coursing",

    // AKC CGC
    canine_good_citizen: "CGC",
    canine_good_citizen_advanced: "CGCA",
    canine_good_citizen_urban: "CGCU",

    // AKC Trick Dog
    tkn: "TKN (Novice)",
    tki: "TKI (Intermediate)",
    tka: "TKA (Advanced)",
    tkp: "TKP (Performer)",
    tke: "TKE (Elite Performer)",

    // AKC Herding:
    started: "Started",
    advance: "Advance",
    herding_sheep: "Sheep",
    herding_cattle: "Cattle",
    herding_ducks: "Ducks",

    // AHBA Herding:
    ahba_level_i: "Level I",
    ahba_level_ii: "Level II",
    ahba_level_iii: "Level III",
    // AHBA test classes (JHD / HCT) also carry their stock as the level
    ahba_goats: "Goats",
    ahba_geese: "Geese",
    ahba_turkeys: "Turkeys",
    ahba_mixed_stock: "Mixed Stock",

    // AKC Agility
    novice_preferred: "Novice Preferred",
    open_preferred: "Open Preferred",
    excellent_preferred: "Excellent Preferred",
    master_preferred: "Master Preferred",
    t2b: "Time 2 Beat",
    t2b_preferred: "Time 2 Beat Preferred",
    premier_standard: "Premier Standard",
    premier_standard_preferred: "Premier Standard Preferred",
    premier_jww: "Premier JWW",
    premier_jww_preferred: "Premier JWW Preferred",

    // UKC Precision Coursing
    // novice: "Novice",
    // advanced: "Advanced",
    // superior: "Superior",
    // master: "Master",
    // elite: "Elite"
    dash: "Dash",
    steeplechase: "Steeplechase",

    // UKC Precision Coursing Non-Licensed classes
    fun_run: "Fun Run",
    puppy_dash: "Puppy Dash",

    // UKC Lure Coursing
    coursing_aptitude: "Coursing Aptitude",
    coursing_ability: "Coursing Ability",
    coursing_tested: "Coursing Tested",
    ct_bye_dog: "CT - Bye Dog",
    regular_stakes: "Regular Stakes",

    // UKC PC Division
    toy: 'T (Toy) 10" & Under',
    one: '1 over 10" - 14"',
    two: '2 over 14" - 20"',
    three: '3 over 20" - 26"',
    g: 'G (Giant) over 26"',

    // UKC Shed Dog
    working_shed_dog: "Working Shed Dog",
    shed_dog_champion: "Champion",
    shed_dog_youth: "Youth",

    dock_jumping_splash_1: "Splash 1",
    dock_jumping_splash_2: "Splash 2",
    dock_jumping_splash_3: "Splash 3",
    dock_jumping_splash_4: "Splash 4",
    dock_jumping_splash_5: "Splash 5",
    dock_jumping_splash_6: "Splash 6",
    dock_jumping_vertical: "Vertical",
    dock_jumping_fetch_it: "Fetch It",
    dock_jumping_raider_run: "Raider Run",

    // PWDCA Water dog
    junior_water_dog: "Junior",
    apprentice: "Apprentice",
    working: "Working",
    courier: "Courier",

    // CPE levels
    speedway: "Speedway",

    // GCR levels
    nitrous_50: "Nitrous 50",
    nitrous_100: "Nitrous 100",

    // AKC Fetch (Title Tracker)
    fetch_novice: "Fetch Novice",
    fetch_intermediate: "Fetch Intermediate",
    fetch_advanced: "Fetch Advanced",
    fetch_retriever: "Fetch Retriever",

    // AKC Obedience (Title Tracker)
    obedience_novice: "Obedience Novice",
    obedience_open: "Obedience Open",
    obedience_utility: "Obedience Utility",

    // AKC Rally (Title Tracker)
    rally_novice: "Rally Novice",
    rally_intermediate: "Rally Intermediate",
    rally_advanced: "Rally Advanced",
    rally_excellent: "Rally Excellent",
    rally_master: "Rally Master",

    // UKC Obedience (Title Tracker)
    ukc_obedience_novice: "UKC Obedience Novice",
    ukc_obedience_open: "UKC Obedience Open",
    ukc_obedience_utility: "UKC Obedience Utility",

    // UKC Rally (Title Tracker)
    ukc_rally_level_1: "UKC Rally Level 1",
    ukc_rally_level_2: "UKC Rally Level 2",
    ukc_rally_level_3: "UKC Rally Level 3",
    ukc_rally_masters: "UKC Rally Masters",
  },

  jump_height_type: {
    none: "None",
    standard: "Standard",
    minimum: "Minimum",
  },

  /** UKC Rally Obedience course setup: sign list or one uploaded image per class. */
  rally_course_mode: {
    exercises: "exercises",
    image: "image",
  },

  payment_method_type: {
    card: "card",
    bank_account: "bank_account",
    cash: "cash",
    etransfer: "e-transfer",
    paypal: "paypal",
    cheque: "cheque",
    other: "other",
    pay_club_directly: "pay_club_directly",
  },

  payment_card_type: {
    unknown: "unknown",
    visa: "visa",
    mastercard: "mastercard",
    amex: "amex",
  },

  registration_kind: {
    owner: "owner",
    club: "club",
  },

  registration_type: {
    event: "event",
    course: "course",
    store: "store",
    donation: "donation",
  },

  add_on_scope: {
    event: "event",
    club: "club",
  },

  discount_type: {
    amount: "amount",
    percentage: "percentage",
    all_offered_classes: "all_offered_classes",
  },
  // events_per_year: {
  //   "0 - 5": "0 - 5",
  //   "6 - 10": "6 - 10",
  //   "10 - 20": "10 - 20",
  //   "20+": "20+",
  // },
  incentive_type: {
    min_number_of_show_types: "min_number_of_show_types",
    number_of_entries: "number_of_entries",
    number_of_entries_fee_percentage: "number_of_entries_fee_percentage",
    number_of_entries_per_event_number: "number_of_entries_per_event_number",
    number_of_entries_per_day: "number_of_entries_per_day",
    number_of_entries_per_show: "number_of_entries_per_show",
    number_of_entries_per_event: "number_of_entries_per_event",
    dogs_per_show: "dogs_per_show",
    all_offered_classes: "all_offered_classes",
    junior_account: "junior_account",
    number_of_shows: "number_of_shows",
    number_of_entries_per_event_per_dog: "number_of_entries_per_event_per_dog",
  },

  form_events: {
    show_judge_books: "show_judge_books",
    show_judge_breeds: "show_judge_breeds",
    event_judge_breeds: "event_judge_breeds",
    show_scoresheets: "show_scoresheets",
    show_scoresheet: "show_scoresheet",
    show_secretary_certification: "show_secretary_certification",
    show_akc_herding_high_in_trial: "show_akc_herding_high_in_trial",
    show_akc_herding_catalog: "show_akc_herding_catalog",
    event_weigh_in_forms: "event_weigh_in_forms",
    event_scoresheets: "event_scoresheets",
    event_scoresheets_condensed: "event_scoresheets_condensed",
    dog_entry_forms: "dog_entry_forms",
    transaction_entry_forms: "transaction_entry_forms",
    event_entry_forms: "event_entry_forms",
    event_registration_list: "event_registration_list",
    event_scores_list: "event_scores_list",
    event_transaction_list: "event_transaction_list",
    event_transaction_summary: "event_transaction_summary",
    event_waitlist_list: "event_waitlist_list",
    event_counts: "event_counts",
    event_counts_formatted: "event_counts_formatted",
    show_type_score_list: "show_type_score_list",
    show_checkin_list: "show_checkin_list",
    show_ring_sheets: "show_ring_sheets",
    show_results: "show_results",
    cwags_scent_results: "cwags_scent_results",
    barn_hunt_results: "barn_hunt_results",
    fast_cat_results_detailed: "fast_cat_results_detailed",
    armband_labels: "armband_labels",
    armband_labels_back: "armband_labels_back",
    armband_labels_5919: "armband_labels_5919",
    armband_labels_5919_back: "armband_labels_5919_back",
    armband_labels_5919_detail: "armband_labels_5919_detail",
    armband_labels_5162: "armband_labels_5162",
    armband_labels_5164: "armband_labels_5164",
    armband_labels_5164_back: "armband_labels_5164_back",
    armband_labels_3perpage: "armband_labels_3perpage",
    armband_labels_4perpage: "armband_labels_4perpage",
    result_ribbon_labels: "result_ribbon_labels",
    scoresheet_labels: "scoresheet_labels",
    event_results_email: "event_results_email",
    show_trial_report: "show_trial_report",
    show_high_in_trial_report: "show_high_in_trial_report",
    show_junior_participation_report: "show_junior_participation_report",
    show_championship_points_report: "show_championship_points_report",
    event_catalog: "event_catalog",
    event_judge_schedule_calculator: "event_judge_schedule_calculator",
    judging_schedule: "judging_schedule",
    interwoven_judging_schedule: "interwoven_judging_schedule",
    run_order: "run_order",
    measurement_report: "measurement_report",
    event_registration_summary: "event_registration_summary",
    event_registration_summary_download: "event_registration_summary_download",
    ukc_total_dog_report: "ukc_total_dog_report",
    ukc_event_counts: "ukc.event.counts",
    akc_results_xml: "akc_results_xml",
    akc_udx_combined_list: "akc_udx_combined_list",
    club_contacts_export: "club_contacts_export",
    club_store_transactions_export: "club_store_transactions_export",
    junior_handler_certificate: "junior_handler_certificate",
    course_session_roster: "course_session_roster",
  },

  form_build_status: {
    pending: "pending",
    generating: "generating",
    complete: "complete",
    error: "error",
  },

  score_status: {
    pending: "pending",
    complete: "complete",
    scratched: "scratched",
    conflict: "conflict",
  },

  move_up_status: {
    active: "active",
    reversed: "reversed",
  },

  waitlist_status: {
    waitlist: "waitlist",
    registered: "registered",
    canceled: "canceled",
    refunded: "refunded",
    pending_refund: "pending_refund",
    refund_denied: "refund_denied",

    // lottery related
    awaiting_payment: "awaiting_payment",
    expired: "expired",
    declined: "declined",
  },

  refund_request_status: {
    requested: "requested",
    approved: "approved",
    denied: "denied",
  },

  score_fault_type: {
    handler_error: "handler_error",
    safety_concern: "safety_concern",
    compromised_area: "compromised_area",
    incorrect_response: "incorrect_response",
    fringe_response: "fringe_response",
    aggressive_response: "aggressive_response",
  },

  score_result_type: {
    qualified: "qualified",
    not_qualified: "not_qualified",
    failed: "failed",
    scratched: "scratched",
    conflict: "conflict",
    non_regular: "non_regular",
    disqualified: "disqualified",
    excused: "excused",
    absent: "absent",
    bitch_in_season: "bitch_in_season",
  },

  cwags_scent_result: {
    pass: "Pass",
    fail: "Fail",
    abs: "ABS",
  },

  akc_fastcat_titles: {
    fcat: "FCAT",
    bcat: "BCAT",
    dcat: "DCAT",
  },

  akc_cat_titles: {
    ca: "CA",
    caa: "CAA",
    cax: "CAX",
    cax2: "CAX 2",
  },

  isws_fast_dash_titles: {
    bfast: "BFAST",
    ifast: "IFAST",
    fast: "FAST",
  },

  cat_result: {
    pass: "Pass",
    fail: "Fail",
    abs: "Absent",
  },

  running_order_dog_class_type: {
    dog_class: "dog_class",
    break: "break",
  },

  // UKC Conformation Best in Show judging blocks on the judge schedule
  ukc_conformation_bis_class: {
    veteran: "Veteran BIS",
    novice_puppy: "Novice Puppy BIS",
    altered: "Altered BIS",
    bis: "BIS",
    total_dog: "Total Dog",
    total_junior: "Total Junior",
  },

  ukc_conformation_bis_default_minutes: 30,

  ring_names: {
    ring_1: "Ring 1",
    ring_2: "Ring 2",
    ring_3: "Ring 3",
    ring_4: "Ring 4",
  },

  running_order_times: {
    break: 60,
    AKC: {
      rally_obedience: {
        novice_a: 3,
        novice_b: 3,
        intermediate: 3,
        advanced_a: 3,
        advanced_b: 3,
        excellent_a: 3,
        excellent_b: 3,
        master: 3,
        choice: 3,
        pairs: 5,
        novice_pairs: 5,
        advanced_pairs: 5,
        excellent_pairs: 5,
        team: 15,
        novice_teams: 15,
        advanced_teams: 15,
      },
      obedience: {
        pre_novice: 6.666666667,
        beginner_novice: 6,
        beginner_novice_a: 6,
        beginner_novice_b: 6,
        preferred_novice: 6.666666667,
        novice_a: 6.666666667,
        novice_b: 6.666666667,
        novice_c: 6.666666667,
        advance_novice: 6.666666667,
        graduate_novice: 6.666666667,
        open_a: 7.5,
        open_b: 7.5,
        advance_open: 7.5,
        preferred_open: 7.5,
        graduate_open: 8.571428571,
        preferred_graduate_open: 8.571428571,
        utility_a: 8.571428571,
        utility_b: 8.571428571,
        preferred_utility: 8.571428571,
        wc_novice: 6.666666667,
        wc_open: 7.5,
        wc_utility: 8.571428571,
        udx: 6.666666667,
        versatility: 10.2,
        veteran: 6.666666667,
        brace: 6.666666667,
        team: 8.4,
      },
    },
    UKC: {
      obedience: {
        pre_novice: 3,
        beginner_novice: 3,
        novice_a: 3,
        novice_b: 3,
        novice_c: 3,
        advance_novice: 3,
        open_a: 3,
        open_b: 3,
        advance_open: 3,
        utility_a: 3,
        utility_b: 3,
        uudx: 3,
        brace: 3,
        team: 3,
        veteran: 3,
      },
      rally_obedience: {
        ro1_a: 3,
        ro1_b: 3,
        ro1_c: 3,
        ro2_a: 3,
        ro2_b: 3,
        ro3_a: 3,
        ro3_b: 3,
        urx: 3,
        rmx: 3,
      },
    },
    CKC: {
      // Starting values mirror AKC per-dog minutes until a CKC judging schedule is available
      obedience: {
        pre_novice: 6,
        novice_a: 6.666666667,
        novice_b: 6.666666667,
        novice_c: 6.666666667,
        ckc_novice_intermediate: 6.666666667,
        open_a: 7.5,
        open_b: 7.5,
        utility_a: 8.571428571,
        utility_b: 8.571428571,
        ckc_exhibition_only: 6.666666667,
        wc_novice: 6.666666667,
        wc_open: 7.5,
        wc_utility: 8.571428571,
        brace: 6.666666667,
        team: 8.4,
        veteran: 6.666666667,
        graduate_novice: 6.666666667,
        graduate_open: 8.571428571,
        ckc_pre_open: 7.5,
        ckc_pre_utility: 8.571428571,
      },
      // CKC Rally Obedience Trial Rules 4.3.2 (15 dogs per hour), 19.2.4 (12 braces per hour), 19.3.7 (4 teams per hour)
      rally_obedience: {
        novice_a: 4,
        novice_b: 4,
        intermediate: 4,
        advanced_a: 4,
        advanced_b: 4,
        excellent_a: 4,
        excellent_b: 4,
        master: 4,
        ckc_exhibition_only: 4,
        brace: 5,
        team: 15,
      },
      // CKC Scent Detection Trial Rules search time limits per component (9.6, 9.7, 9.8 charts);
      // Interior Excellent is two areas and Master up to three areas at 3 minutes each
      scent_detection: {
        scent_detection_container: {
          scent_detection_instinct: 2,
          scent_detection_novice: 2,
          scent_detection_open: 2,
          scent_detection_excellent: 3,
          scent_detection_master: 3,
        },
        scent_detection_interior: {
          scent_detection_novice: 3,
          scent_detection_open: 3,
          scent_detection_excellent: 6,
          scent_detection_master: 9,
        },
        scent_detection_exterior: {
          scent_detection_novice: 4,
          scent_detection_open: 4,
          scent_detection_excellent: 5,
          scent_detection_master: 5,
        },
      },
    },
    PWDCA: {
      water_dog: {
        junior: 10,
        apprentice: 15,
        working: 15,
        courier: 20,
        master: 20,
      },
    },
  },

  deductions: {
    heel_on_leash: "Heel on Leash",
    figure_eight: "Figure Eight",
    sit_for_exam: "Sit for Exam",
    sit_stay: "Sit Stay",
    recall: "Recall",
    misc: "Miscellaneous Penalties",
    heel_on_leash_figure_eight: "Heel on Leash and Figure Eight",
    stand_for_exam: "Stand for Exam",
    heel_free: "Heel Free",
    stay_sit_or_down: "Stay Sit or Down",
    sit_stay_get_your_leash: "Sit Stay Get Your Leash",
    heel_free_figure_eight: "Heel Free and Figure Eight",
    figure_eight_heel_free: "Figure Eight and Heel Free",
    cmd_disc_stand_down_sit: "Command Disc. Stand Down Sit",
    cmd_disc_down_sit_stand: "Command Disc. Down Sit Stand",
    cmd_disc_down_stand_sit: "Command Disc. Down Stand Sit",
    cmd_disc_stand_sit_down: "Command Disc. Stand Sit Down",
    drop_on_recall: "Drop on Recall",
    retrieve_on_flat: "Retrieve on Flat",
    retrieve_over_high_jump: "Retrieve Over High Jump",
    broad_jump: "Broad Jump",
    stand_stay_get_your_leash: "Stand Stay Get Your Leash",
    group_sit_and_down: "Group Sit and Down",
    heel_free_figure_eight_off_leash: "Heel Free and Figure Eight Off Leash",
    dumbbell_recall: "Dumbbell Recall",
    dumbbell_recall_over_high_jump: "Dumbbell Recall Over High Jump",
    recall_over_broad_jump: "Recall Over Broad Jump",
    signal_exercise: "Signal Exercise",
    scent_disc: "Scent Discrimination",
    scent_disc_art_1: "Scent Discrimination Article 1",
    scent_disc_art_2: "Scent Discrimination Article 2",
    go_out: "Go Out",
    directed_jumping: "Directed Jumping",
    moving_stand_and_exam: "Moving Stand and Exam",
    directed_retrieve: "Directed Retrieve",
    minor_deduction: "Minor Deduction",
    minor_or_substantial_deduction: "Minor or Substantial Deduction",
    substantial_deduction: "Substantial Deduction",
    non_qualfying: "Non-Qualifying",
    greeting: "Greeting",
    honor: "Honor",
    heel_off_leash: "Heel off Leash",
    recall_over_high_jump: "Recall Over High Jump",
    serpentine_loop_three_cones: "Serpentine Loop 3 Cones",
    down_stay: "Down Stay",
    straight_recall: "Straight Recall",
    stand_sit_for_exam: "Stand or Sit for Exam",
    down_stay_walk_away: "Down Stay Walk Away",
    moving_down: "Moving Down",
    recall_over_jump: "Recall Over Jump",
    heel_off_leash_figure_eight: "Heel Off Leash and Figure Eight",
    socialized_heeling: "Socialized Heeling",
    heel_off_leash_with_moving_exercise: "Heel Off Leash with Moving Exercise",
    figure_eight_with_down_stay: "Figure Eight With Down Stay",
    retrieve_of_an_object: "Retrieve of an Object",
    scent_discrimination: "Scent Discrimination",
    send_away_to_box: "Send Away to Box",
    signal_heeling: "Signal and Heeling",
    scent_work: "Scent Work",
    option_1_turn_and_send: "Option 1 Turn and Send",
    option_2_sit: "Option 2 Sit",
    directed_marked_retrieve: "Directed Marked Retrieve",
    directed_signal_retrieve: "Directed Signal Retrieve",
    consecutive_recall: "Consecutive Recall",

    signal_heeling_with_moving_stand_for_exam:
      "Signal Heeling with Moving Stand for Exam",
    food_refusal: "Food Refusal",
    recall_with_stand_and_down: "Recall with Stand and Down",
    advanced_directed_retrieve_and_jumping:
      "Advanced Directed Retrieve and Jumping",
    unfamiliar_scent_discrimination: "Unfamiliar Scent Discrimination",

    seek_back: "Seek Back",
    positions_with_recall: "Positions With Recall",
    send_to_cone_and_return: "Send to Cone and Return",
    send_away_with_dumbbell_retrieve: "Send Away with Dumbbell Retrieve",
    handler_discrimination: "Handler Discrimination",

    halt_sit: "Halt – Sit",
    halt_sit_walk_around: "Halt – Sit – Walk Around",
    right_turn: "Right Turn",
    left_turn: "Left Turn",
    about_turn_right: "About Turn – Right",
    two_hundred_seventy_degree_right_turn: "270 Degree Right Turn",
    two_hundred_seventy_degree_left_turn: "270 Degree Left Turn",
    three_hundred_sixty_degree_right_turn: "360 Degree Right Turn",
    three_hundred_sixty_degree_left_turn: "360 Degree Left Turn",
    serpentine_weave: "Serpentine Weave",
    fast_pace: "Fast Pace",
    slow_pace: "Slow Pace",
    call_front_finish_right_forward: "Call Front – Finish Right – Forward",
    call_front_finish_left_forward: "Call Front – Finish Left – Forward",
    halt_sit_down: "Halt – Sit – Down",
    halt_sit_down_walk_around_dog: "Halt – Sit – Down – Walk Around Dog",
    halt_stand: "Halt – Stand",
    halt_stand_walk_around_dog: "Halt – Stand – Walk Around Dog",
    straight_figure_eight_no_distractions:
      "Straight Figure Eight No Distractions",
    u_turn: "U-Turn",
    spiral_left_no_distractions: "Spiral Left No Distractions",
    spiral_right_no_distractions: "Spiral Right No Distractions",

    halt_sit_down_recall: "Halt – Sit – Down – Recall",
    halt_down_walk_around_dog: "Halt – Down – Walk Around Dog",
    halt_sit_stand_walk_around_dog: "Halt – Sit – Stand – Walk Around Dog",
    halt_stand_walk_around_dog_recall:
      "Halt – Stand – Walk Around Dog – Recall",
    halt_sit_right_turn_forward: "Halt – Sit – Right Turn – Forward",
    halt_sit_left_turn_forward: "Halt – Sit – Left Turn – Forward",
    right_pivot: "Right Pivot",
    left_pivot: "Left Pivot",
    call_front_one_step_back_finish_right:
      "Call Front – 1 Step Back – Finish Right",
    send_over_jump_return_to_heel: "Send Over Jump – Return to Heel",
    serpentine_weave_distractions: "Serpentine Weave Distractions",
    spiral_left_distractions: "Spiral Left Distractions",
    spiral_right_distractions: "Spiral Right Distractions",

    halt_call_front_two_steps_back_forward:
      "Halt – Call Front – 2 Steps Back – Forward",
    halt_stand_leave_call_to_heel: "Halt – Stand – Leave – Call to Heel",
    moving_stand: "Moving Stand",
    stand_leave_turn_call_to_heel: "Stand – Leave – Turn – Call to Heel",
    halt_sit_right_turn_forward_sit: "Halt – Sit – Right Turn – Forward – Sit",
    halt_sit_left_turn_forward_sit: "Halt – Sit – Left Turn – Forward – Sit",
    send_over_jump_recall: "Send Over Jump – Recall",
    halt_ninety_degree_right_pivot_sit: "Halt – 90° Right Pivot – Sit",
    halt_ninety_degree_left_pivot_sit: "Halt – 90° Left Pivot – Sit",
    halt_one_hundred_eighty_degree_right_pivot_sit:
      "Halt – 180° Right Pivot – Sit",
    halt_one_hundred_eighty_degree_left_pivot_sit:
      "Halt – 180° Left Pivot – Sit",

    halt_call_front_three_steps_back_forward:
      "Halt – Call Front – 3 Steps Back – Forward",
    halt_stand_walk_around_dog_call_to_heel:
      "Halt – Stand – Walk Around Dog – Call to Heel",
    halt_moving_down_walk_around_dog: "Halt – Moving Down – Walk Around Dog",
    halt_moving_stand_walk_around_dog: "Halt – Moving Stand – Walk Around Dog",
    halt_stand_leave_turn_call_to_heel:
      "Halt – Stand – Leave – Turn – Call to Heel",
    halt_drop_on_recall: "Halt – Drop on Recall",
    halt_stand_stay_send_over_jump_recall:
      "Halt – Stand – Stay – Send Over Jump – Recall",
    moving_side_step_right: "Moving Side Step Right",
    halt_stand_pivot_right_forward: "Halt – Stand – Pivot Right – Forward",
    halt_stand_pivot_left_forward: "Halt – Stand – Pivot Left – Forward",
    backup_three_steps_while_heeling: "Backup 3 Steps While Heeling",
    halt_stand_back_three_steps_forward:
      "Halt – Stand – Back 3 Steps – Forward",
    moving_stand_stay_call_to_heel: "Moving Stand – Stay – Call to Heel",
    halt_down_walk_around_call_to_heel:
      "Halt – Down – Walk Around – Call to Heel",

    halt: "Halt",
    //halt_stand: "Halt – Stand",
    halt_down: "Halt – Down",
    halt_down_sit: "Halt – Down – Sit",
    halt_walk_around_dog: "Halt – Walk Around Dog",
    //halt_down_walk_around_dog: "Halt – Down – Walk Around Dog",
    //right_turn: "Right Turn",
    //left_turn: "Left Turn",
    //about_turn_right: "About Turn - Right (180°)",
    about_turn_right_left_turn: "About Turn Right – Left Turn",
    about_u_turn: "About 'U' Turn",
    about_u_turn_left_right_turn: "About 'U' Turn Left – Right Turn",
    turn_270_right: "270° Right Turn",
    turn_270_left: "270° Left Turn",
    turn_360_right: "360° Right Turn",
    turn_360_left: "360° Left Turn",
    halt_90_pivot_right_halt: "Halt – 90° Pivot Right – Halt",
    halt_90_pivot_right_forward: "Halt – 90° Pivot Right & Forward",
    call_dog_front_handler_returns: "Call Dog Front – Handler Returns",
    call_dog_front_dog_right_forward: "Call Dog Front – Dog Right & Forward",
    call_dog_front_dog_left_forward: "Call Dog Front – Dog Left & Forward",
    call_dog_front_finish_right_halt: "Call Dog Front – Finish Right – Halt",
    call_dog_front_finish_left_halt: "Call Dog Front – Finish Left – Halt",
    //slow_pace: "Slow Pace",
    //fast_pace: "Fast Pace",
    normal_pace: "Normal Pace",
    //moving_side_step_right: "Moving Side Step Right",
    halt_side_step_right_forward: "Halt – Side Step Right & Forward",
    spiral_right_dog_outside: "Spiral Right – Dog Outside",
    spiral_left_dog_inside: "Spiral Left – Dog Inside",
    serpentine_4_cones: "Serpentine – 4 Cones",
    serpentine_5_cones: "Serpentine – 5 Cones",
    serpentine_loop_4_cones: "Serpentine Loop – 4 Cones",
    serpentine_loop_5_cones: "Serpentine Loop – 5 Cones",
    curl_dog_inside_3_cones: "Curl – Dog Inside – 3 Cones",
    curl_dog_outside_3_cones: "Curl – Dog Outside – 3 Cones",
    ribbon_loop_right: "Ribbon Loop – Right",
    halt_sit_stand: "Halt – Sit – Stand",
    // halt_sit_down: "Halt – Sit – Down",
    halt_sit_down_sit: "Halt – Sit – Down – Sit",
    //halt_sit_walk_around: "Halt – Sit – Walk Around",
    halt_stand_walk_around: "Halt – Stand – Walk Around",
    //halt_down_walk_around_call_to_heel: "Halt – Down – Walk Around – Call to Heel",
    halt_down_stand: "Halt – Down – Stand",
    halt_down_stand_walk_around: "Halt – Down – Stand – Walk Around",
    side_step_left: "Side Step Left",
    side_step_right: "Side Step Right",
    halt_180_pivot_right_halt: "Halt – 180° Pivot Right – Halt",
    halt_180_pivot_left_halt: "Halt – 180° Pivot Left – Halt",
    back_up_3_steps: "Back Up 3 Steps",
    back_up_3_steps_halt: "Back Up 3 Steps – Halt",
    //drop_on_recall: "Drop on Recall",
    //recall_over_jump: "Recall Over Jump",
    retrieve_dumbbell: "Retrieve Dumbbell",
    send_to_cone: "Send to Cone",
    send_to_box: "Send to Box",
    honor_stay: "Honor Stay",
    off_leash_pivot_right: "Off-Leash Pivot Right",
    off_leash_pivot_left: "Off-Leash Pivot Left",
    figure_8_heeling: "Figure 8 Heeling",
    change_of_pace_sit: "Change of Pace – Sit",
    distance_control: "Distance Control",
    directed_jump: "Directed Jump",
    off_leash_heeling_patterns: "Off-Leash Heeling Patterns",
    //directed_retrieve: "Directed Retrieve",
    stay_with_distraction: "Stay with Distraction",
    handler_disc_choice: "Handler's Discretionary Choice",

    halt_leave_dog_face_dog_call_front_return_left:
      "HALT - Leave Dog, Face Dog, Call to Front, Handler Returns Left",
    halt_leave_dog_face_dog_call_front_return_right:
      "HALT - Leave Dog, Face Dog, Call to Front, Handler Returns Right",
    halt_sit_walk_around_cone:
      "HALT - Sit, Handler Walks Around Cone, Back to Dog",
    halt_down_walk_around_cone:
      "HALT - Down, Handler Walks Around Cone, Back to Dog",
    halt_leave_face_dog_down_return_forward:
      "HALT - Leave & Face Dog, Down Dog, Return & Forward",
    offset_figure_8: "Offset Figure 8",
    call_front_1_2_3_steps_back_right_forward:
      "Call Dog Front - 1, 2 & 3 Steps Backward - Dog Right & Forward",
    call_front_1_2_3_steps_back_left_forward:
      "Call Dog Front - 1, 2 & 3 Steps Backward - Dog Left & Forward",
    double_pivot_90_left_halt: "Double Pivot 90° Left - HALT",
    double_pivot_90_right_halt: "Double Pivot 90° Right - HALT",
    triple_loop_left: "Triple Loop Left",
    triple_loop_right: "Triple Loop Right",
    halt_90_pivot_left_forward: "HALT - 90° Pivot Left & Forward",
    halt_90_pivot_left_halt: "HALT - 90° Pivot Left - HALT",
    halt_about_turn_right_forward: "HALT - About Turn Right & Forward",
    halt_about_u_turn_forward: "HALT - About 'U' Turn & Forward",
    halt_90_pivot_right_halt_90_pivot_right_forward:
      "HALT 90° Pivot Right - HALT - 90° Pivot Right & Forward",
    halt_90_pivot_left_halt_90_pivot_left_forward:
      "HALT 90° Pivot Left - HALT - 90° Pivot Left & Forward",
    moving_down_forward_from_down: "Moving Down - Forward From Down",
    halt_pivot_90_left_call_heel: "HALT, Pivot 90° Left, Call Dog To Heel",
    halt_pivot_90_right_call_heel: "HALT - Pivot 90° Right, Call Dog To Heel",
    halt_turn_180_right_call_heel_halt:
      "HALT - Turn 180° To Right, Call Dog Heel - HALT",

    //RO1
    //halt: "HALT",
    //halt_stand: "HALT - Stand",
    //halt_down: "HALT - Down",
    //halt_down_sit: "HALT - Down - Sit",
    //halt_walk_around_dog: "HALT - Walk Around Dog",
    //halt_down_walk_around_dog: "HALT - Down - Walk Around Dog",
    //right_turn: "Right Turn",
    //left_turn: "Left Turn",
    //about_turn_right: "About Turn - Right (180°)",
    //about_turn_right_left_turn: "About Turn Right - Left Turn",
    //about_u_turn: "About 'U' Turn",
    //about_u_turn_left_right_turn: "About 'U' Turn Left - Right Turn",
    //turn_270_right: "270° Right Turn",
    //turn_270_left: "270° Left Turn",
    //turn_360_right: "360° Right Turn",
    //turn_360_left: "360° Left Turn",
    //halt_90_pivot_right_halt: "HALT - 90° Pivot Right - HALT",
    //halt_90_pivot_right_forward: "HALT - 90° Pivot Right & Forward",
    //call_dog_front_handler_returns: "Call Dog Front - Handler Returns",
    //call_dog_front_dog_right_forward: "Call Dog Front - Dog Right & Forward",
    //call_dog_front_dog_left_forward: "Call Dog Front - Dog Left & Forward",
    //call_dog_front_finish_right_halt: "Call Dog Front - Finish Right - HALT",
    //call_dog_front_finish_left_halt: "Call Dog Front - Finish Left - HALT",
    //slow_pace: "Slow Pace",
    //fast_pace: "Fast Pace",
    //normal_pace: "Normal Pace",
    //moving_side_step_right: "Moving Side Step Right",
    //halt_side_step_right_forward: "HALT - Side Step Right & Forward",
    //spiral_right_dog_outside: "Spiral Right - Dog Outside",
    //spiral_left_dog_inside: "Spiral Left - Dog Inside",
    //serpentine_4_cones: "Serpentine 4 Cones",
    //serpentine_5_cones: "Serpentine 5 Cones",
    //serpentine_loop_4_cones: "Serpentine Loop 4 Cones",
    //serpentine_loop_5_cones: "Serpentine Loop 5 Cones",
    //curl_dog_inside_3_cones: "Curl - Dog Inside 3 Cones",
    //curl_dog_outside_3_cones: "Curl - Dog Outside 3 Cones",
    //ribbon_loop_right: "Ribbon Loop Right",
    ribbon_loop_left: "Ribbon Loop Left",
    figure_8_to_right: "Figure 8 To Right (Using Cones)",
    figure_8_to_left: "Figure 8 To Left (Using Cones)",
    halt_1_2_3_steps_forward: "HALT - 1, 2, 3 Steps Forward",
    shift_right: "Shift Right",
    shift_left: "Shift Left",
    right_turn_150: "Right Turn (150)",
    right_turn_151: "Right Turn (151)",
    left_turn_152: "Left Turn (152)",
    left_turn_153: "Left Turn (153)",
    about_turn_right_154: "About Turn Right (154)",
    about_turn_left_155: "About Turn Left (155)",
    turn_270_right_156: "270° Right Turn (156)",
    turn_270_left_157: "270° Left Turn (157)",
    normal_pace_158: "Normal Pace (158)",
    start: "Start",
    finish: "Finish",
    enter: "Enter",
    exit: "Exit",

    //RO2
    halt_leave_face_dog_call_front_finish_right:
      "HALT, Leave-Face Dog, Call Dog Front - Finish Right",
    halt_leave_face_dog_call_front_finish_left:
      "HALT-Leave-Face Dog, Call Dog Front, Finish Left",
    //halt_sit_walk_around_cone: "HALT - Sit, Handler Walks Around Cone, Back To Dog",
    //halt_down_walk_around_cone: "HALT - Down, Handler Walks Around Cone, Back To Dog",
    //halt_leave_face_dog_down_return_forward: "HALT - Leave & Face Dog, Down Dog, Return & Forward",
    //offset_figure_8: "Offset Figure 8",
    //call_front_1_2_3_steps_back_right_forward: "Call Dog Front - 1, 2 & 3 Steps Backward - Dog Right & Forward",
    //call_front_1_2_3_steps_back_left_forward: "Call Dog Front - 1, 2 & 3 Steps Backward - Dog Left & Forward",
    //double_pivot_90_left_halt: "Double Pivot 90° Left - HALT",
    //double_pivot_90_right_halt: "Double Pivot 90° Right - HALT",
    //triple_loop_left: "Triple Loop Left",
    //triple_loop_right: "Triple Loop Right",
    //halt_90_pivot_left_forward: "HALT - 90° Pivot Left & Forward",
    //halt_90_pivot_left_halt: "HALT - 90° Pivot Left - HALT",
    //halt_about_turn_right_forward: "HALT - About Turn Right & Forward",
    //halt_about_u_turn_forward: "HALT - About 'U' Turn & Forward",
    //halt_90_pivot_right_halt_90_pivot_right_forward: "HALT 90° Pivot Right - HALT - 90° Pivot Right & Forward",
    //halt_90_pivot_left_halt_90_pivot_left_forward: "HALT 90° Pivot Left - HALT - 90° Pivot Left & Forward",
    //moving_down_forward_from_down: "Moving Down - Forward From Down",
    //halt_pivot_90_left_call_heel: "HALT, Pivot 90° Left, Call Dog To Heel",
    //halt_pivot_90_right_call_heel: "HALT - Pivot 90° Right, Call Dog To Heel",
    //halt_turn_180_right_call_heel_halt: "HALT - Turn 180° To Right, Call Dog Heel - HALT",
    halt_leave_dog_face_dog_call_front_handler_return_left:
      "HALT - Leave Dog, Face Dog, Call to Front, Handler Returns Left",
    halt_leave_dog_face_dog_call_front_handler_return_right:
      "HALT - Leave Dog, Face Dog, Call to Front, Handler Returns Right",

    //RO3
    //halt_180_pivot_right_halt: "HALT - 180° Pivot Right - HALT",
    //halt_180_pivot_left_halt: "HALT - 180° Pivot Left - HALT",
    halt_180_pivot_right_halt_90_pivot_left_halt:
      "HALT – 180° Pivot Right – HALT – 90° Pivot Left – HALT",
    halt_180_pivot_left_halt_90_pivot_right_halt:
      "HALT - 180° Pivot Left – HALT - 90° Pivot Right – HALT",
    moving_down_handler_forward_face_dog_call_dog_finish_right:
      "Moving Down – Handler Forward – Face Dog – Call Dog – Finish Right",
    moving_down_handler_forward_face_dog_call_dog_finish_left:
      "Moving Down – Handler Forward – Face Dog – Call Dog – Finish Left",
    halt_send_dog_around_front_back_to_heel:
      "HALT, Send Dog Around Front of Handler & Back to Heel, HALT",
    halt_fast_forward_from_sit: "HALT - Fast Forward from Sit",
    left_about_turn: "Left About Turn",
    halt_stand_sit: "HALT - Stand - Sit",
    halt_stand_down: "HALT - Stand - Down",
    //halt_stand_walk_around_dog: "HALT - Stand - Walk Around Dog",
    halt_stand_heel_backward_3_steps_halt:
      "HALT - Stand - Heel Backward 3 Steps - HALT",
    halt_handler_walks_to_cone_call_dog_to_heel:
      "HALT - Handler Walks to Cone, Call Dog to Heel",
    send_over_jump_handler_runs_by: "Send Over Jump - Handler Runs By",
    turn_left_90_double_step_back_forward:
      "Turn Left 90°, Double Step Back, Forward",
    turn_right_90_double_step_back_forward:
      "Turn Right 90°, Double Step Back, Forward",
    halt_leave_dog_face_dog_call_to_heel_right:
      "HALT - Leave Dog, Face Dog, Call to Heel Right",
    halt_leave_dog_face_dog_call_to_heel_left:
      "HALT - Leave Dog, Face Dog, Call to Heel Left",
    moving_stand_walk_around_cone_back_to_dog:
      "Moving Stand, Walk Around Cone, Back to Dog",
    moving_sit_walk_around_cone_back_to_dog:
      "Moving Sit, Walk Around Cone, Back to Dog",
    moving_down_walk_around_cone_back_to_dog:
      "Moving Down, Walk Around Cone, Back to Dog",
    moving_down_handler_forward_call_dog_to_heel:
      "Moving Down, Handler Forward, Call Dog to Heel",
    moving_sit_handler_forward_call_dog_to_heel:
      "Moving Sit, Handler Forward, Call Dog To Heel",
    moving_stand_handler_forward_call_dog_to_heel:
      "Moving Stand, Handler Forward, Call Dog To Heel",
    honor_sit: "Honor Sit (Time Limit 1 1/2 Minutes)",
    honor_down: "Honor Down (Time Limit 1 1/2 Minutes)",

    //ROM
    call_dog_front_90_pivot_right_finish_left:
      "Call Dog Front, 90° Pivot Right, Finish Left",
    call_dog_front_90_pivot_left_finish_right:
      "Call Dog Front, 90° Pivot Left, Finish Right",
    halt_leave_call_dog_over_broad_jump_front_finish_right:
      "HALT - Leave - Call Dog Over Broad Jump - Front - Finish Right",
    halt_leave_call_dog_over_broad_jump_front_finish_left:
      "HALT - Leave - Call Dog Over Broad Jump - Front - Finish Left",
    halt_90_pivot_right_halt_180_pivot_left_halt:
      "HALT - 90° Pivot Right - HALT - 180° Pivot Left - HALT",
    halt_90_pivot_left_halt_180_pivot_right_halt:
      "HALT - 90° Pivot Left - HALT - 180° Pivot Right - HALT",
    forward_reverse_3_steps_pivot_90_left_forward:
      "Forward, Reverse 3 Steps, Pivot 90° Left & Forward",
    forward_reverse_3_steps_pivot_90_right_forward:
      "Forward, Reverse 3 Steps, Pivot 90° Right & Forward",
    spiral_in_dog_outside_spiral_out_dog_inside:
      "Spiral In - Dog Outside | Spiral Out - Dog Inside",
    spiral_in_dog_inside_spiral_out_dog_outside:
      "Spiral In – Dog Inside – Spiral Out – Dog Outside",
    halt_side_step_right_halt_270_right_turn_forward:
      "HALT - Side Step Right - HALT 270° Right Turn & Forward",
    halt_side_step_right_halt_270_left_turn_forward:
      "HALT - Side Step Right - HALT - 270° Left Turn & Forward",
    moving_stand_walk_to_cone_halt_call_dog_to_heel:
      "Moving Stand - Walk to Cone - HALT - Call Dog to Heel",
    moving_sit_walk_to_cone_halt_call_dog_to_heel:
      "Moving Sit - Walk to Cone - HALT - Call Dog to Heel",
    moving_down_walk_to_cone_halt_call_dog_to_heel:
      "Moving Down - Walk to Cone - HALT - Call Dog to Heel",
    moving_stand_handler_forward_face_dog_down_sit_finish_right:
      "Moving Stand, Handler Forward, Face Dog, Dog Down, Dog Sit, Finish Right",
    moving_stand_handler_forward_face_dog_down_sit_finish_left:
      "Moving Stand, Handler Forward, Face Dog, Dog Down, Dog Sit, Finish Left",
    cloverleaf: "Cloverleaf",
    halt_send_dog_around_cone_dog_front_handler_returns_right:
      "HALT Send Dog Around Cone, Dog Front, Handler Returns Right",
    halt_send_dog_around_cone_front_finish_right_180_pivot_right_forward:
      "HALT - Send Dog Around Cone, Front, Finish Right - 180° Pivot Right - Forward",
    halt_send_dog_around_cone_front_finish_left_180_pivot_right_forward:
      "HALT - Send Dog Around Cone - Front - Finish Left, 180° Pivot Right - Forward",
    halt_send_dog_around_cone_return_to_heel_right_180_pivot_right_forward:
      "HALT - Send Dog Around Cone - Return to Heel Right - 180° Pivot Right - Forward",
    halt_send_dog_forward_around_cone_return_to_heel_left_180_pivot_right_forward:
      "HALT - Send Dog Forward Around Cone - Return to Heel Left - 180° Pivot Right - Forward",
    halt_leave_dog_call_dog_over_jump_dog_front_handler_returns_right:
      "HALT – Leave Dog – Call Dog Over Jump – Dog Front - Handler Returns Right",

    //AKC Obedience Versitility
    scent_discrimination_metal: "Scent Discrimination (Metal)",
    scent_discrimination_leather: "Scent Discrimination (Leather)",
  },

  // Junior Armband
  junior_arm_band_classes: [
    "Junior Showmanship", // dog_class_element.junior_showmanship,
  ],

  ukc_deduction_reasons: {
    //
    handler_error: "Handler Error",
    disciplining_dog: "Disciplining Dog",
    unsportsmanlike_conduct: "Unsportsmanlike Conduct",
    dog_misbehaviour: "Dog Misbehaviour",
  },

  ukc_non_qualifying_reasons: {
    dog_shows_fear: "Dog Shows Fear",
    fouling_ring: "Fouling Ring",
  },

  none: "None",

  // Live running status of a trial (show), set by secretaries and pushed to
  // exhibitors in real time. See getTrialStatusLabel() for display strings.
  trial_status: {
    not_started: "not_started",
    running: "running",
    break: "break",
    complete: "complete",
  },

  waitlist_options: {
    none: "none",
    daily_judge_time_limit: "daily_judge_time_limit",
    daily_trial_time_limit: "daily_trial_time_limit",
    daily_judge_mrv_limit: "daily_judge_mrv_limit",
    show_dog_limit: "show_dog_limit",
    show_entry_limit: "show_entry_limit",
    per_level_limit: "per_level_limit",
    entries_per_judge: "entries_per_judge",
  },

  // BHA MRV (Maximum Run Value) multipliers per level.
  // Run Value = number of entries at that level × multiplier.
  // Summed per judge per day and compared against the show's waitlist_limit (the assigned MRV).
  bha_mrv_multipliers: {
    barn_hunt_instinct: 1.0,
    barn_hunt_line_drive: 1.0,
    barn_hunt_novice: 1.5,
    barn_hunt_open: 2.0,
    barn_hunt_senior: 2.5,
    barn_hunt_crazy_8s: 2.5,
    barn_hunt_master: 3.0,
  },

  breed_restriction_mode: {
    exclude: "exclude",
    allow: "allow",
  },

  breed_filter_type: {
    all: "all",
    breeds: "breeds",
    breed_groups: "breed_groups",
  },

  dog_wheelchair_options: {
    none: "None",
    manual: "Manual",
    electric: "Electric",
  },

  // Title Tracker Constants
  title_requirement_type: {
    points: "points",
    legs: "legs",
    points_increment: "points_increment",
    double_q: "double_q",
    triple_q: "triple_q",
    title_dependency: "title_dependency",
  },

  run_data_source: {
    eagerdog_event: "eagerdog_event",
    manual_entry: "manual_entry",
    csv_import: "csv_import",
  },

  fast_cat_height_class: {
    eighteen_plus: ">=18",
    twelve_to_eighteen: "12-18",
    under_twelve: "<12",
  },

  run_result_status: {
    qualified: "Q",
    not_qualified: "NQ",
    absent: "ABS",
    disqualified: "DQ",
    excused: "EXC",
    scratched: "SCR",
  },

  ukc_obedience_award: {
    high_in_trial: "High in Trial",
    high_combined: "High Combined",
    high_scoring_dog: "High Scoring Dog",
  },

  ukc_rally_class: {
    level_1: "Level 1",
    level_1_a: "Level 1 A",
    level_1_b: "Level 1 B",
    level_2: "Level 2",
    level_2_a: "Level 2 A",
    level_2_b: "Level 2 B",
    level_3: "Level 3",
    level_3_a: "Level 3 A",
    level_3_b: "Level 3 B",
    masters: "Masters",
    masters_a: "Masters A",
    masters_b: "Masters B",
  },

  platform_fees_by: {
    owner: "owner",
    club: "club",
  },
};

// ----------------
// Helper Functions
// ----------------

/**
 * Check if a UKC Agility level is a games class.
 * Games classes do not use the standard agility score field.
 */
export const isUkcAgilityDynamicClass = (level: string): boolean => {
  return [
    Constants.dog_class_element_level.novice_hurdles,
    Constants.dog_class_element_level.elite_hurdles,
    Constants.dog_class_element_level.novice_tunnels,
    Constants.dog_class_element_level.elite_tunnels,
    Constants.dog_class_element_level.three_of_a_kind,
  ].includes(level);
};

/**
 * Check if UKC Agility level is specifically 3 of a Kind.
 */
export const isUkcAgilityThreeOfAKindClass = (level: string): boolean => {
  return level === Constants.dog_class_element_level.three_of_a_kind;
};

/**
 * Check if UKC Agility games class uses faults (hurdles/tunnels).
 */
export const isUkcAgilityFaultsClass = (level: string): boolean => {
  return [
    Constants.dog_class_element_level.novice_hurdles,
    Constants.dog_class_element_level.elite_hurdles,
    Constants.dog_class_element_level.novice_tunnels,
    Constants.dog_class_element_level.elite_tunnels,
  ].includes(level);
};

/**
 * Lottery events force waitlist pooling and skip checkout only while the
 * random draw has not been run. After lottery_ran_at is set, leftover spots
 * register and pay like a normal show.
 */
export const isLotteryDrawOpen = (event?: {
  is_lottery?: boolean;
  lottery_ran_at?: Date | string | null;
} | null): boolean => {
  return !!event?.is_lottery && !event?.lottery_ran_at;
};
